<template>
    <div>
        <h1 class="subtitle is-3 login__title">Личный кабинет</h1>
        <div class="columns">
            <div class="column is-4 is-offset-4">
                <section>
                    <b-field label="Email:">
                        <b-input type="email"
                                 v-model="creditionals.email"
                                 name="email">
                        </b-input>
                    </b-field>
                    <b-field label="Пароль: ">
                        <b-input type="password"
                                 v-model="creditionals.password"
                                 password-reveal
                                 name="password"
                                 @keyup.enter.native="auth">
                        </b-input>
                    </b-field>
                </section>
                <div class="login__button">
                    <b-button type="is-primary" icon-right="arrow-right" @click="auth()">Войти</b-button>
                </div>
            </div>
        </div>
        <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
</template>

<script>
export default {
  name: 'AdminLogin',
  data() {
    return {
      creditionals: {
        email: '',
        password: '',
        phone: '',
      },
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters.AUTH_IS_LOADING;
    },
    isLoggedIn() {
      return this.$store.getters.IS_LOGGED_IN;
    },
    token() {
      return this.$store.getters.AUTH_TOKEN;
    },
  },
  created() {
    console.log('this.isLoggedIn');
    console.log(this.isLoggedIn);
    if (this.isLoggedIn) {
      console.log('token');
      console.log(this.token);
      this.$store.dispatch('AUTH_BY_TOKEN', this.token)
        .then(() => {
          this.$router.push({ path: '/users' }).catch(()=>{});
        });
    }
  },
  methods: {
    auth() {
      this.$store.dispatch('SET_AUTH_CREDITIONALS', this.creditionals);
      this.$store.dispatch('ADMIN_AUTH')
        .then(() => {
          this.$router.push({ path: '/users' });
        })
        .catch(() => {
          this.$toast.open({
            duration: 3000,
            message: 'Ошибка авторизации',
            position: 'is-bottom',
            type: 'is-danger',
          });
        });
    },
  },
};
</script>

<style>
    .login__title {
        text-align: center;
    }

    .login__button {
        text-align: center;
        margin-top: 30px;
    }
</style>
